module.exports = __webpack_public_path__ + "img/error.83f607f3.svg";